import { connect } from 'react-redux';
import Author from './author';
import fetchAuthor from '../../../shared/actions/fetchers/fetchAuthor';
import { goToNextAuthor, goToPrevAuthor } from '../../../shared/actions/navigateUtils';

function mapStateToProps(state) {
  const { authorContext: { data: contextData = {} }, authors } = state;
  const { index, data } = authors;

  const authorList = contextData['author-group'] || [];
  const authorName = authorList[index] || {};
  const authorCount = authorList.length;
  const hasNext = index + 1 < authorCount;
  const hasPrev = index > 0;

  return {
    authorName,
    authorCount,
    hasNext,
    hasPrev,
    author: data[index],
    index,
  };
}

const mapDispatchToProps = dispatch => ({
  fetchAuthor: index => dispatch(fetchAuthor(index)),
  goToNext: () => dispatch(goToNextAuthor()),
  goToPrev: () => dispatch(goToPrevAuthor()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Author);
